export default __webpack_public_path__ + "static/media/speelplaats.b969a758.svg";